import { gql } from '@apollo/client';

export const UpdatePublishDefinitionPage = gql`
mutation UpdatePublishDefinitionPage($updatePublishDefinitionPageId: ID!, $publish: Boolean!) {
  updatePublishDefinitionPage(id: $updatePublishDefinitionPageId, publish: $publish) {
    status
  }
}
`;